export default "<div class=\"container aligncontainer\" >\r\n    <p-progressSpinner></p-progressSpinner>\r\n  </div>\r\n  "